import React from 'react';
import {StringParam, useQueryParam} from 'use-query-params';
import {CookieConsentContext} from '../../context/CookieConsentContext';
import {AFF_NET, CookieConsentCategory, R2O_ENV, R2O_OS, R2O_REFERRER, UTM_CAMPAIGN, UTM_CONTENT, UTM_MEDIUM, UTM_SOURCE} from '../../types/cookieType';

export const StoreUtmParams: React.FC<Record<string, unknown>> = () => {
  const [env] = useQueryParam('env', StringParam);
  const [os] = useQueryParam('os', StringParam);
  const [utmSource] = useQueryParam('utm_source', StringParam);
  const [utmMedium] = useQueryParam('utm_medium', StringParam);
  const [utmCampaign] = useQueryParam('utm_campaign', StringParam);
  const [utmContent] = useQueryParam('utm_content', StringParam);
  const [getPromoAccount] = useQueryParam('getPromoAccount', StringParam);
  const [r2oReferrer] = useQueryParam(R2O_REFERRER, StringParam);
  const [affiliateNetworkId] = useQueryParam('s_id', StringParam);
  const {setCookie, acceptedCategories} = React.useContext(CookieConsentContext);

  React.useEffect(() => {
    const paramsCookie = {
      [R2O_ENV]: env,
      [R2O_OS]: os,
      [UTM_SOURCE]: utmSource,
      [UTM_MEDIUM]: utmMedium,
      [UTM_CAMPAIGN]: utmCampaign,
      [UTM_CONTENT]: utmContent,
      [AFF_NET]: affiliateNetworkId
    };

    for (const [cookieName, paramValue] of Object.entries(paramsCookie)) {
      if (paramValue) {
        // AFF_NET is currently treated as ESSENTIAL, we store it no matter what
        // only difference is whether it has a 30 day expiration, or it only lives for a session
        // TODO: INTSERVICE-1389
        if (cookieName === AFF_NET && acceptedCategories.has(CookieConsentCategory.PERSONALISED_ADVERTISING)) {
          setCookie(cookieName, paramValue, null, true, 30);
        } else {
          setCookie(cookieName, paramValue);
        }
      }
    }

    if (getPromoAccount) {
      setCookie(R2O_REFERRER, 'r2o-promo');
    } else if (r2oReferrer) {
      setCookie(R2O_REFERRER, r2oReferrer);
    }
  }, [affiliateNetworkId, acceptedCategories]);

  return <React.Fragment />;
};
